export const blockIconsSocialPsychologyNew = (
	<span className='material-symbols-outlined'>psychology</span>
);
